// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { lazy } from 'react';

import { HydrateFallback } from '../../Loaders/RootLoader/rootLoader';
import { withSuspense } from '../../../hooks/LazyLoader/withSuspense';

import { equipmentGroupLoader } from '../../Loaders/EquipmentGroupLoader/EquipmentGroupLoader';
import { equipmentLoader } from '../../Loaders/EquipmentLoader/EquipmentLoader';
import { controlLoader } from '../../Loaders/ControlLoader/ControlLoader';
import { equipmentControlLoader } from '../../Loaders/EquipmentControlLoader/EquipmentControlLoader';
import { cameraControlLoader } from '../../Loaders/CameraControlLoader/CameraControlLoader';

const lazyPage = path => lazy(() => import(`../../Pages/${path}`));

const Facility = lazyPage('Facility');
const EquipmentDetail = lazyPage('EquipmentDetail');
const GroupEquipment = lazyPage('GroupEquipment');
const CameraControl = lazyPage('CameraControl');
const CameraControlRedirect = lazyPage('CameraControlRedirect');
const CameraGroupControl = lazyPage('CameraGroupControl');
const CameraEquipmentControl = lazyPage('CameraEquipmentControl');
const ButtonAssignment = lazyPage('ButtonAssignment');

const Multiview = lazyPage('Multiview');

// Nodes Routes
const nodesRoutes = [
  {
    path: '',
    element: withSuspense(Facility),
    HydrateFallback,
    children: [
      {
        path: 'equipmentGroup/:equipmentGroupId',
        loader: equipmentGroupLoader,
        shouldRevalidate: ({ currentParams, nextParams }) =>
          currentParams.equipmentGroupId !== nextParams.equipmentGroupId,
        element: withSuspense(GroupEquipment),
        HydrateFallback,
      },
      {
        loader: equipmentLoader,
        path: 'equipment/:equipmentId',
        element: withSuspense(EquipmentDetail),
        shouldRevalidate: ({ currentParams, nextParams }) =>
          currentParams.equipmentId !== nextParams.equipmentId,
        HydrateFallback,
        children: [
          {
            path: 'console',
            element: withSuspense(ButtonAssignment),
          },
          {
            path: 'multiview',
            element: withSuspense(Multiview),
          },
        ],
      },
    ],
  },
  {
    path: ':equipmentGroupId/cameracontrol',
    loader: cameraControlLoader,
    element: withSuspense(CameraControl),
    shouldRevalidate: ({ currentParams, nextParams }) =>
      currentParams.equipmentGroupId !== nextParams.equipmentGroupId,
    HydrateFallback,
    children: [
      {
        index: true,
        element: withSuspense(CameraControlRedirect),
      },
      {
        path: ':cameraGroupId',
        loader: controlLoader,
        element: withSuspense(CameraGroupControl), // TODO: create own loader to only fetch camereGroup by id
        shouldRevalidate: ({ currentParams, nextParams }) =>
          currentParams.cameraGroupId !== nextParams.cameraGroupId,
        HydrateFallback,
      },
      {
        path: 'eq/:cameraId',
        loader: equipmentControlLoader,
        element: withSuspense(CameraEquipmentControl),
        shouldRevalidate: ({ currentParams, nextParams }) =>
          currentParams.cameraId !== nextParams.cameraId ||
          currentParams.equipmentGroupId !== nextParams.equipmentGroupId,
        HydrateFallback,
      },
    ],
  },
];

export default nodesRoutes;
